import type { HelpFile } from '../../types/help'
import { NotificationHistoryTestIds } from '../../../testids/NotificationHistoryTestIds'

export const notificationHistoryHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [NotificationHistoryTestIds.notificationHistoryTitle]:
      'Persönliche Benachrichtigungshistorie — alle vom System gesendeten Benachrichtigungen mit Lese-Indikatoren.',
    [NotificationHistoryTestIds.colDate]: null,
    [NotificationHistoryTestIds.colEventType]: null,
    [NotificationHistoryTestIds.colMessage]: null,
    [NotificationHistoryTestIds.colReadIndicator]:
      'Lese-Indikator — ein farbiger Punkt kennzeichnet ungelesene Benachrichtigungen; er verschwindet, sobald die Benachrichtigung geöffnet wurde.',
  },
}
